/* eslint-disable react/display-name */
import React from "react";
import { useSearchContext } from "../../contexts/searchcontext.ts";
import CardStatsList from "./CardStatsList";
import { usePopularChartContext } from "../../contexts/popularchartcontext";
import { ENTITY_TYPES } from "utils/constants";

const CardList = ({ entityType = ENTITY_TYPES.CARD, showMarketCapStat }) => {
  const { popularCardStats, popularSealedWaxStats } = useSearchContext();
  const { cards, sealedWaxes, hiddenLines } = usePopularChartContext();

  const [label, entities, stats] = {
    [ENTITY_TYPES.CARD]: ["Cards", cards, popularCardStats],
    [ENTITY_TYPES.SEALED_WAX]: ["Wax", sealedWaxes, popularSealedWaxStats],
  }[entityType];

  const data = entities.reduce((acc, entity) => {
    if (hiddenLines[entity.id]) {
      return acc;
    } else {
      acc = [...acc, { stats: stats[entity.id] || {}, ...entity }];
      return acc;
    }
  }, []);

  if (!Object.keys(stats).length) {
    return null;
  }

  return (
    <>
      {entities.length > 0 && <h2 style={{ margin: "30px 0" }}>{label} Stats</h2>}
      <CardStatsList data={data} entityType={entityType} showMarketCapStat={showMarketCapStat} />
    </>
  );
};

export default CardList;
